module.exports = __webpack_public_path__ + "img/favorite-icon.1b2d1936.svg";